const updatedPromosList = (promos, code) => {
  const promoList = document.querySelector('.promo-list');
  const popupCancelPromoBtn = document.querySelector(
    '.promocode-popup .remove-promo',
  );
  const promocodePopupInput = document.querySelector(
    '.promocode-popup .promocode-input input',
  );
  const promocodeDescription = document.querySelector(
    '.promocode-popup .promo-description',
  );
  const promoError = document.querySelector('.promocode-popup .promo-error');
  const promocodePopupInputWrapper = document.querySelector(
    '.promocode-popup .promocode-input',
  );
  const promobannersPopup = document.querySelectorAll('.promo-banner');

  if (promobannersPopup) {
    [].forEach.call(promobannersPopup, (banner) => {
      const promoId = banner.dataset.promotion;
      const title = banner.querySelector('.sale-title');
      const successIcon = banner.querySelector('.promo-success');
      const errorIcon = banner.querySelector('.promo-failed');
      const successTitle = banner.querySelector('.success-title');
      const errorTitle = banner.querySelector('.error-title');

      const currentPromotion = promos.find((item) => item.id === promoId);

      if (currentPromotion) {
        if (title) {
          title.classList.add('with-response');
        }

        if (currentPromotion.active) {
          if (successIcon) {
            successIcon.classList.add('visible');
          }

          if (errorIcon) {
            errorIcon.classList.remove('visible');
          }

          if (successTitle) {
            successTitle.classList.add('visible');
          }

          if (errorTitle) {
            errorTitle.classList.remove('visible');
          }
        } else {
          if (successIcon) {
            successIcon.classList.remove('visible');
          }

          if (errorIcon) {
            errorIcon.classList.add('visible');
          }

          if (successTitle) {
            successTitle.classList.remove('visible');
          }

          if (errorTitle) {
            errorTitle.classList.add('visible');
          }
        }
      } else {
        if (title && title.classList.contains('with-response')) {
          title.classList.remove('with-response');
        }

        if (successIcon && successIcon.classList.contains('visible')) {
          successIcon.classList.remove('visible');
        }

        if (errorIcon && errorIcon.classList.contains('visible')) {
          errorIcon.classList.remove('visible');
        }

        if (successTitle && successTitle.classList.contains('visible')) {
          successTitle.classList.remove('visible');
        }

        if (errorTitle && errorTitle.classList.contains('visible')) {
          errorTitle.classList.remove('visible');
        }
      }
    });
  }

  let splicedPromos;
  let currentTextPromo;

  if (promoList) {
    promoList.innerHTML = '';
  }

  if (code) {
    currentTextPromo = promos.find((item) => item.data.code === code);
  } else {
    currentTextPromo = promos.find(
      (item) => item.type === 'promocode' && !item.hidden,
    );
  }

  if (currentTextPromo) {
    const filteredPromos = promos.filter(
      (item) => item.data.code !== currentTextPromo.data.code,
    );

    const promoItem = document.createElement('button');
    const promoContent = document.createElement('div');
    const promoName = document.createElement('span');

    const validIcon =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z" fill="#6ACE3C"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8266 7.17764C14.5955 6.94078 14.2207 6.94078 13.9895 7.17768L8.7622 12.5353L6.01052 9.71503C5.77939 9.47813 5.40456 9.47813 5.17338 9.71503C4.94221 9.95193 4.94221 10.3361 5.17338 10.573L8.34361 13.8223C8.4592 13.9408 8.6107 14 8.76217 14C8.91363 14 9.06517 13.9407 9.18072 13.8223L14.8266 8.03565C15.0578 7.79875 15.0578 7.41458 14.8266 7.17764Z" fill="#6ACE3C"/></svg>';
    const errorIcon =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281ZM9.2951 5.46527C9.2951 5.07596 9.6107 4.76037 10 4.76037C10.3893 4.76037 10.7049 5.07596 10.7049 5.46527V12.1406C10.7049 12.5299 10.3893 12.8455 10 12.8455C9.6107 12.8455 9.2951 12.5299 9.2951 12.1406V5.46527ZM10 13.6526C9.53277 13.6526 9.15399 14.0313 9.15399 14.4986C9.15399 14.9658 9.53277 15.3446 10 15.3446C10.4673 15.3446 10.846 14.9658 10.846 14.4986C10.846 14.0313 10.4673 13.6526 10 13.6526Z" fill="#F02F2E"/></svg>';

    promoItem.classList.add(
      'promo',
      'medium',
      'very-small-text',
      'show-popup-btn',
    );
    promoItem.dataset.id = 'promocode-popup';
    promoContent.classList.add('promo-content');

    if (currentTextPromo.name) {
      promoItem.setAttribute('title', currentTextPromo.name);
    }

    if (currentTextPromo.active) {
      promoContent.innerHTML = validIcon;
    } else {
      promoContent.innerHTML = errorIcon;
    }

    if (currentTextPromo.data && currentTextPromo.data.code) {
      promoName.textContent = currentTextPromo.data.code;
    } else {
      promoName.textContent = currentTextPromo.name;
    }

    promoContent.append(promoName);
    promoItem.append(promoContent);

    if (promoList) {
      promoList.append(promoItem);
    }

    if (popupCancelPromoBtn) {
      popupCancelPromoBtn.dataset.code = currentTextPromo.data.code;
    }

    if (promocodePopupInput) {
      promocodePopupInput.value = currentTextPromo.data.code;
    }

    if (promocodeDescription) {
      if (currentTextPromo.name) {
        promocodeDescription.classList.add('visible');

        let promoDescriptionText;

        if (currentTextPromo.description) {
          promoDescriptionText = currentTextPromo.description;
        } else {
          promoDescriptionText = currentTextPromo.name;
        }

        if (currentTextPromo.active) {
          promocodeDescription.textContent = `Вы выполнили условия акции: ${promoDescriptionText}`;
        } else {
          promocodeDescription.textContent = `Вы не выполнили условия акции: ${promoDescriptionText}`;
        }
      }
    }

    if (promoError) {
      if (currentTextPromo.name) {
        if (currentTextPromo.active) {
          promoError.textContent = 'Условия выполнены';
          promoError.classList.add('green-color');
        } else {
          promoError.textContent = 'Условия не выполнены';
          promoError.classList.remove('green-color');
        }
      } else {
        promoError.textContent = 'Введен неверный промокод';
      }
    }

    if (promocodePopupInputWrapper) {
      if (currentTextPromo.active) {
        promocodePopupInputWrapper.classList.remove('error');
        promocodePopupInputWrapper.classList.add('valid');
      } else {
        promocodePopupInputWrapper.classList.remove('valid');
        promocodePopupInputWrapper.classList.add('error');
      }
    }

    splicedPromos = filteredPromos.splice(0, 2);
  } else {
    splicedPromos = promos.splice(0, 3);
  }

  splicedPromos.forEach((promo) => {
    const promoItem = document.createElement('div');

    const validIcon =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z" fill="#6ACE3C"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.8266 7.17764C14.5955 6.94078 14.2207 6.94078 13.9895 7.17768L8.7622 12.5353L6.01052 9.71503C5.77939 9.47813 5.40456 9.47813 5.17338 9.71503C4.94221 9.95193 4.94221 10.3361 5.17338 10.573L8.34361 13.8223C8.4592 13.9408 8.6107 14 8.76217 14C8.91363 14 9.06517 13.9407 9.18072 13.8223L14.8266 8.03565C15.0578 7.79875 15.0578 7.41458 14.8266 7.17764Z" fill="#6ACE3C"/></svg>';
    const errorIcon =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0711 2.92891C15.1823 1.0402 12.6711 0 10 0C7.32887 0 4.81762 1.0402 2.92891 2.92891C1.04016 4.81766 0 7.32891 0 10C0 12.6711 1.04016 15.1823 2.92891 17.0711C4.81766 18.9598 7.32887 20 10 20C12.6711 20 15.1823 18.9598 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10C20 7.32891 18.9598 4.8177 17.0711 2.92891ZM10 18.8281C5.13215 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13215 5.13215 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13215 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281ZM9.2951 5.46527C9.2951 5.07596 9.6107 4.76037 10 4.76037C10.3893 4.76037 10.7049 5.07596 10.7049 5.46527V12.1406C10.7049 12.5299 10.3893 12.8455 10 12.8455C9.6107 12.8455 9.2951 12.5299 9.2951 12.1406V5.46527ZM10 13.6526C9.53277 13.6526 9.15399 14.0313 9.15399 14.4986C9.15399 14.9658 9.53277 15.3446 10 15.3446C10.4673 15.3446 10.846 14.9658 10.846 14.4986C10.846 14.0313 10.4673 13.6526 10 13.6526Z" fill="#F02F2E"/></svg>';

    promoItem.classList.add('promo', 'medium', 'very-small-text');

    if (promo.name) {
      promoItem.setAttribute('title', promo.name);
    } else {
      promoItem.setAttribute('title', promo.data.code);
    }

    let promoName = promo.name;

    if (promo.data && promo.data.code && !promo.hidden) {
      promoName = promo.data.code;
    }

    promoItem.innerHTML = `<div class="promo-content">${
      promo.active ? validIcon : errorIcon
    }
      <span>
        ${promoName}
      </span>
    </div>`;

    if (promoList) {
      promoList.append(promoItem);
    }
  });
};

export default updatedPromosList;
